import feedbackState from './feedbackReducers';
import managerNotesState from './managerNotesReducer';
import surveyState from './surveyReducer';
import { combineReducers } from 'redux';
import optionalSurveyState from './optionalSurveyReducer';

export default combineReducers({
    surveyState,
    feedbackState,
    optionalSurveyState,
    managerNotesState,
});
